import React from 'react';
import { NavLink } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';

import '../assets/css/Guide2.css';

import Footer from "../components/Footer";
import { GuideDoc } from '../components/GuideDoc';

import TFAILogoMain from '../assets/images/TFAI-logo-main.svg'
import ListUpBannerFilm from '../assets/images/cnt-head-01.jpg'

const Guide = ({deviceSize}) => {
    const getAPIDocTitle = () => {
        switch (deviceSize) {
            case 'A':
                return '30px'
            case 'B':
                return '30px'
            case 'C':
                return '35px'
            default:
                return '40px'
        }
    }
    const activeClass = (id)=>{
        const element = document.getElementById('div'+id);
        element.className = 'APIDocLeftAreaMinorOptionSelected';
    }
    const inactiveClass = (id)=>{
        const element = document.getElementById('div'+id);
        element.className = 'APIDocLeftAreaMinorOption';
    }
    return (<>
        <div className="TFAI-box-guide" >
            <div id="content-bg">
                <aside></aside>
                <div className="ctn-pic">
                    <img alt="guideHead" src={ListUpBannerFilm} />
                </div>
            </div>
            <div className="container-xl">
                <div className="ctn-header">
                    <div className="ctn-logo d-none d-lg-block">
                        <NavLink to="/"><img src={TFAILogoMain} alt="TFAT logo" className="img-fluid" /></NavLink>
                    </div>
                    <div className="ctn-heading">
                        <h1><span>國家電影及視聽文化中心 藏品檢索系統</span>使用說明</h1>
                    </div>
                </div>
                <div className={"APIDocMainPage"} >
                    <div className={"GuideDocRightArea"} style={{width: deviceSize==="A"||deviceSize==="B"?'100%':'85%'}} >
                        <div style={{ width:'100%', height:100, backgroundColor:'white' }}></div>
                        <div style={{ fontSize: getAPIDocTitle() }}>{GuideDoc.mainTitle}</div>
                        <div className={"APIDocText"}>{GuideDoc.mainText}</div>
                        {GuideDoc.paragraph.map((section, index) => (
                            <div key={index} className='APIDocRightAreaMainOption'>
                                <div id={section.number+section.pTitle}>
                                    <div className='APIDocRightAreaMainOptionTitle'>{section.number + " " + section.pTitle}</div>
                                    <div className={"APIDocRightAreaMainOptionText"} dangerouslySetInnerHTML={{ __html: section.pText }}></div>
                                    {section.image &&
                                        <div className={"GuideImageContainer"}>
                                            <img alt="img" className={"GuideImage"} src={require(`../assets/images/${section.image}.jpg`)}></img>
                                        </div>
                                    }
                                </div>
                                {section.subParagraph.map((subSection, subIndex) => (
                                    <div key={subIndex} id={subSection.number+subSection.spTitle} className='APIDocRightAreaMinorOption'>
                                        <div className='APIDocRightAreaMinorOptionTitle'>{subSection.number+" "+subSection.spTitle}</div>
                                        {subSection.image &&
                                            <div className={"GuideImageContainer"}>
                                                <img alt="subimg" className={"GuideImage"} src={require(`../assets/images/${subSection.image}.jpg`)}></img>
                                            </div>
                                        }
                                        <div className='APIDocRightAreaMinorOptionText' dangerouslySetInnerHTML={{ __html: subSection.spText }}></div>
                                        {subSection.thirdLevelParagraph &&
                                            subSection.thirdLevelParagraph.map((para, i) => (   
                                                para.type === 'text' ? <div key={i} className={"APIDocRightAreaMinorOptionText"}>{para.text}</div> :
                                                    <div key={i} className={"GuideImageContainer"}>
                                                        <img alt="thirdimg" className={"GuideImage"} src={require(`../assets/images/${para.image}.jpg`)}></img>
                                                    </div>
                                            ))
                                        }
                                    </div>                                    
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
                <div style={{ width: '100%', height: '300px' }}></div>
            </div>
            {deviceSize === "E" || deviceSize === "D" ?
                <div className='APIDocLeftArea'>
                    <div style={{ margin: 17 }}>
                        {GuideDoc.paragraph.map((section, index) => (
                            <div key={index} className='APIDocLeftAreaMainOption'>
                                <ScrollLink to={section.number+section.pTitle} activeClass='APIDocLeftAreaMinorOptionSelected' spy offset={-50}
                                    onSetActive={()=>activeClass(section.number+section.pTitle)} 
                                    onSetInactive={()=>inactiveClass(section.number+section.pTitle)}>
                                    <div id={`div${section.number+section.pTitle}`} className='APIDocLeftAreaMinorOption'>
                                        <div className='APIDocLeftAreaMainOptionTitle'  style={{ fontSize:'15px'}}>{section.number+" "+section.pTitle}</div>
                                    </div>
                                </ScrollLink>
                                {section.subParagraph.map((subSection, subIndex) => (
                                    <ScrollLink key={subIndex} to={subSection.number+subSection.spTitle} 
                                        activeClass='APIDocLeftAreaMinorOptionSelected' spy offset={-50}
                                        onSetActive={()=>activeClass(subSection.number+subSection.spTitle)} 
                                        onSetInactive={()=>inactiveClass(subSection.number+subSection.spTitle)}>
                                        <div id={`div${subSection.number+subSection.spTitle}`} className='APIDocLeftAreaMinorOption'>                                       
                                            <div className='APIDocLeftAreaMinorOptionTitle'>{subSection.number+" "+subSection.spTitle}</div>
                                        </div>
                                    </ScrollLink>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
                : null
            }
            <Footer />
        </div>
    </>)
}
export default Guide 